import React, { FC } from 'react';

import { BadgesContainer } from './BadgesContainer';
import { WarningBadge } from './Badge';

type Props = {
    readonly product: any;
};

const WarningBadgeList: FC<Props> = props => {
    const badges = props.product?.badges?.warningBadges ?? [];

    const warningBadges = badges.map(productWarningBadge => ({
        title: productWarningBadge.title,
        badgeKey: productWarningBadge.key,
        badgeComponent: WarningBadge
    }));

    return <BadgesContainer {...props} layout="list" showAll={true} badges={warningBadges} />;
};

export default WarningBadgeList;
